//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL_IDENTITY = new InjectionToken<string>('API_BASE_URL_IDENTITY');

export interface IIdentityClient {
    /**
     * @return OK
     */
    getSites(): Observable<SiteConfiguration[]>;
    /**
     * @param site (optional) 
     * @return OK
     */
    getUserInfo(site: string | undefined): Observable<UserInfo>;
    /**
     * @return OK
     */
    login(body: LoginRequest): Observable<AccessTokenResponse>;
    /**
     * @return OK
     */
    refresh(body: RefreshRequest): Observable<AccessTokenResponse>;
    /**
     * @param changedEmail (optional) 
     * @return OK
     */
    confirmEmail(userId: string, code: string, changedEmail: string | undefined): Observable<void>;
    /**
     * @return OK
     */
    resendConfirmationEmail(body: ResendConfirmationEmailRequest): Observable<void>;
    /**
     * @return OK
     */
    forgotPassword(body: ForgotPasswordRequest): Observable<void>;
    /**
     * @return OK
     */
    resetPassword(body: ResetPasswordRequest): Observable<void>;
    /**
     * @return OK
     */
    changeExpiredPassword(body: ChangeExpiredPasswordRequest): Observable<AccessTokenResponse>;
    /**
     * @return OK
     */
    logout(body: any): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class IdentityClient implements IIdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_IDENTITY) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getSites(): Observable<SiteConfiguration[]> {
        let url_ = this.baseUrl + "/api/identity/GetSites";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SiteConfiguration[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SiteConfiguration[]>;
        }));
    }

    protected processGetSites(response: HttpResponseBase): Observable<SiteConfiguration[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SiteConfiguration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param site (optional) 
     * @return OK
     */
    getUserInfo(site: string | undefined): Observable<UserInfo> {
        let url_ = this.baseUrl + "/api/identity/GetUserInfo?";
        if (site === null)
            throw new Error("The parameter 'site' cannot be null.");
        else if (site !== undefined)
            url_ += "site=" + encodeURIComponent("" + site) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfo>;
        }));
    }

    protected processGetUserInfo(response: HttpResponseBase): Observable<UserInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    login(body: LoginRequest): Observable<AccessTokenResponse> {
        let url_ = this.baseUrl + "/api/identity/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenResponse>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<AccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    refresh(body: RefreshRequest): Observable<AccessTokenResponse> {
        let url_ = this.baseUrl + "/api/identity/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefresh(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefresh(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenResponse>;
        }));
    }

    protected processRefresh(response: HttpResponseBase): Observable<AccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param changedEmail (optional) 
     * @return OK
     */
    confirmEmail(userId: string, code: string, changedEmail: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/confirmEmail?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (changedEmail === null)
            throw new Error("The parameter 'changedEmail' cannot be null.");
        else if (changedEmail !== undefined)
            url_ += "changedEmail=" + encodeURIComponent("" + changedEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resendConfirmationEmail(body: ResendConfirmationEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/resendConfirmationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendConfirmationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResendConfirmationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    forgotPassword(body: ForgotPasswordRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    resetPassword(body: ResetPasswordRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/resetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changeExpiredPassword(body: ChangeExpiredPasswordRequest): Observable<AccessTokenResponse> {
        let url_ = this.baseUrl + "/api/identity/changeExpiredPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeExpiredPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeExpiredPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenResponse>;
        }));
    }

    protected processChangeExpiredPassword(response: HttpResponseBase): Observable<AccessTokenResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    logout(body: any): Observable<void> {
        let url_ = this.baseUrl + "/api/identity/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IManageClient {
    /**
     * @return OK
     */
    _2fa(body: TwoFactorRequest): Observable<TwoFactorResponse>;
    /**
     * @return OK
     */
    infoGet(): Observable<ProfileViewModel>;
    /**
     * @return OK
     */
    infoPost(body: ProfileViewModel): Observable<ProfileViewModel>;
    /**
     * @return OK
     */
    changePassword(body: InfoRequest): Observable<ProfileViewModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ManageClient implements IManageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_IDENTITY) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    _2fa(body: TwoFactorRequest): Observable<TwoFactorResponse> {
        let url_ = this.baseUrl + "/api/identity/manage/2fa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.process_2fa(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.process_2fa(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TwoFactorResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TwoFactorResponse>;
        }));
    }

    protected process_2fa(response: HttpResponseBase): Observable<TwoFactorResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TwoFactorResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    infoGet(): Observable<ProfileViewModel> {
        let url_ = this.baseUrl + "/api/identity/manage/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfoGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfoGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileViewModel>;
        }));
    }

    protected processInfoGet(response: HttpResponseBase): Observable<ProfileViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    infoPost(body: ProfileViewModel): Observable<ProfileViewModel> {
        let url_ = this.baseUrl + "/api/identity/manage/info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInfoPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInfoPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileViewModel>;
        }));
    }

    protected processInfoPost(response: HttpResponseBase): Observable<ProfileViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    changePassword(body: InfoRequest): Observable<ProfileViewModel> {
        let url_ = this.baseUrl + "/api/identity/manage/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileViewModel>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ProfileViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileViewModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IClient {
    /**
     * @return OK
     */
    codeWorkspace(): Observable<ICode[]>;
    /**
     * @return OK
     */
    sysApplicationSite(): Observable<ISysCode[]>;
    /**
     * @return OK
     */
    sysJobStatus(): Observable<ISysCode[]>;
    /**
     * @return OK
     */
    sysReportType(): Observable<ISysCode[]>;
}

@Injectable({
    providedIn: 'root'
})
export class Client implements IClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL_IDENTITY) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    codeWorkspace(): Observable<ICode[]> {
        let url_ = this.baseUrl + "/CodeWorkspace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCodeWorkspace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCodeWorkspace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ICode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ICode[]>;
        }));
    }

    protected processCodeWorkspace(response: HttpResponseBase): Observable<ICode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ICode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sysApplicationSite(): Observable<ISysCode[]> {
        let url_ = this.baseUrl + "/SysApplicationSite";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSysApplicationSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSysApplicationSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ISysCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ISysCode[]>;
        }));
    }

    protected processSysApplicationSite(response: HttpResponseBase): Observable<ISysCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ISysCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sysJobStatus(): Observable<ISysCode[]> {
        let url_ = this.baseUrl + "/SysJobStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSysJobStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSysJobStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ISysCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ISysCode[]>;
        }));
    }

    protected processSysJobStatus(response: HttpResponseBase): Observable<ISysCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ISysCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    sysReportType(): Observable<ISysCode[]> {
        let url_ = this.baseUrl + "/SysReportType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSysReportType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSysReportType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ISysCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ISysCode[]>;
        }));
    }

    protected processSysReportType(response: HttpResponseBase): Observable<ISysCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ISysCode.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AccessTokenResponse implements IAccessTokenResponse {
    readonly TokenType!: string;
    AccessToken!: string;
    ExpiresIn!: number;
    RefreshToken!: string;

    constructor(data?: IAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.AccessToken = "";
            this.ExpiresIn = 0;
            this.RefreshToken = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).TokenType = _data["TokenType"] !== undefined ? _data["TokenType"] : <any>null;
            this.AccessToken = _data["AccessToken"] !== undefined ? _data["AccessToken"] : "";
            this.ExpiresIn = _data["ExpiresIn"] !== undefined ? _data["ExpiresIn"] : 0;
            this.RefreshToken = _data["RefreshToken"] !== undefined ? _data["RefreshToken"] : "";
        }
    }

    static fromJS(data: any): AccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["TokenType"] = this.TokenType !== undefined ? this.TokenType : <any>null;
        data["AccessToken"] = this.AccessToken !== undefined ? this.AccessToken : <any>null;
        data["ExpiresIn"] = this.ExpiresIn !== undefined ? this.ExpiresIn : <any>null;
        data["RefreshToken"] = this.RefreshToken !== undefined ? this.RefreshToken : <any>null;
        return data;
    }
}

export interface IAccessTokenResponse {
    TokenType: string;
    AccessToken: string;
    ExpiresIn: number;
    RefreshToken: string;
}

export class ChangeExpiredPasswordRequest implements IChangeExpiredPasswordRequest {
    Email!: string;
    OldPassword!: string;
    NewPassword!: string;

    constructor(data?: IChangeExpiredPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Email = "";
            this.OldPassword = "";
            this.NewPassword = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Email = _data["Email"] !== undefined ? _data["Email"] : "";
            this.OldPassword = _data["OldPassword"] !== undefined ? _data["OldPassword"] : "";
            this.NewPassword = _data["NewPassword"] !== undefined ? _data["NewPassword"] : "";
        }
    }

    static fromJS(data: any): ChangeExpiredPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeExpiredPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        data["OldPassword"] = this.OldPassword !== undefined ? this.OldPassword : <any>null;
        data["NewPassword"] = this.NewPassword !== undefined ? this.NewPassword : <any>null;
        return data;
    }
}

export interface IChangeExpiredPasswordRequest {
    Email: string;
    OldPassword: string;
    NewPassword: string;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    Email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Email = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Email = _data["Email"] !== undefined ? _data["Email"] : "";
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        return data;
    }
}

export interface IForgotPasswordRequest {
    Email: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors!: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
        if (!data) {
            this.errors = {};
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static override fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors: { [key: string]: string[]; };

    [key: string]: any;
}

export class ICode implements IICode {
    Code!: string;
    Description?: string | null;
    Active!: boolean;
    Sequence!: number;

    constructor(data?: IICode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Code = "";
            this.Active = false;
            this.Sequence = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Code = _data["Code"] !== undefined ? _data["Code"] : "";
            this.Description = _data["Description"] !== undefined ? _data["Description"] : <any>null;
            this.Active = _data["Active"] !== undefined ? _data["Active"] : false;
            this.Sequence = _data["Sequence"] !== undefined ? _data["Sequence"] : 0;
        }
    }

    static fromJS(data: any): ICode {
        data = typeof data === 'object' ? data : {};
        let result = new ICode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Code"] = this.Code !== undefined ? this.Code : <any>null;
        data["Description"] = this.Description !== undefined ? this.Description : <any>null;
        data["Active"] = this.Active !== undefined ? this.Active : <any>null;
        data["Sequence"] = this.Sequence !== undefined ? this.Sequence : <any>null;
        return data;
    }
}

export interface IICode {
    Code: string;
    Description?: string | null;
    Active: boolean;
    Sequence: number;
}

export class ISysCode implements IISysCode {
    SysValue!: string;
    Description?: string | null;
    Active!: boolean;
    Sequence!: number;

    constructor(data?: IISysCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.SysValue = "";
            this.Active = false;
            this.Sequence = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.SysValue = _data["SysValue"] !== undefined ? _data["SysValue"] : "";
            this.Description = _data["Description"] !== undefined ? _data["Description"] : <any>null;
            this.Active = _data["Active"] !== undefined ? _data["Active"] : false;
            this.Sequence = _data["Sequence"] !== undefined ? _data["Sequence"] : 0;
        }
    }

    static fromJS(data: any): ISysCode {
        data = typeof data === 'object' ? data : {};
        let result = new ISysCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SysValue"] = this.SysValue !== undefined ? this.SysValue : <any>null;
        data["Description"] = this.Description !== undefined ? this.Description : <any>null;
        data["Active"] = this.Active !== undefined ? this.Active : <any>null;
        data["Sequence"] = this.Sequence !== undefined ? this.Sequence : <any>null;
        return data;
    }
}

export interface IISysCode {
    SysValue: string;
    Description?: string | null;
    Active: boolean;
    Sequence: number;
}

export class InfoRequest implements IInfoRequest {
    NewEmail?: string | null;
    NewPassword?: string | null;
    OldPassword?: string | null;

    constructor(data?: IInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.NewEmail = _data["NewEmail"] !== undefined ? _data["NewEmail"] : <any>null;
            this.NewPassword = _data["NewPassword"] !== undefined ? _data["NewPassword"] : <any>null;
            this.OldPassword = _data["OldPassword"] !== undefined ? _data["OldPassword"] : <any>null;
        }
    }

    static fromJS(data: any): InfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["NewEmail"] = this.NewEmail !== undefined ? this.NewEmail : <any>null;
        data["NewPassword"] = this.NewPassword !== undefined ? this.NewPassword : <any>null;
        data["OldPassword"] = this.OldPassword !== undefined ? this.OldPassword : <any>null;
        return data;
    }
}

export interface IInfoRequest {
    NewEmail?: string | null;
    NewPassword?: string | null;
    OldPassword?: string | null;
}

export class LoginRequest implements ILoginRequest {
    Email!: string;
    Password!: string;
    TwoFactorCode?: string | null;
    TwoFactorRecoveryCode?: string | null;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Email = "";
            this.Password = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Email = _data["Email"] !== undefined ? _data["Email"] : "";
            this.Password = _data["Password"] !== undefined ? _data["Password"] : "";
            this.TwoFactorCode = _data["TwoFactorCode"] !== undefined ? _data["TwoFactorCode"] : <any>null;
            this.TwoFactorRecoveryCode = _data["TwoFactorRecoveryCode"] !== undefined ? _data["TwoFactorRecoveryCode"] : <any>null;
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        data["Password"] = this.Password !== undefined ? this.Password : <any>null;
        data["TwoFactorCode"] = this.TwoFactorCode !== undefined ? this.TwoFactorCode : <any>null;
        data["TwoFactorRecoveryCode"] = this.TwoFactorRecoveryCode !== undefined ? this.TwoFactorRecoveryCode : <any>null;
        return data;
    }
}

export interface ILoginRequest {
    Email: string;
    Password: string;
    TwoFactorCode?: string | null;
    TwoFactorRecoveryCode?: string | null;
}

export class ProfileViewModel implements IProfileViewModel {
    Id!: string;
    UserName!: string;
    Email!: string;
    FirstName?: string | null;
    LastName?: string | null;
    Company?: string | null;
    Title?: string | null;
    IsEmailConfirmed!: boolean;

    constructor(data?: IProfileViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Id = "";
            this.UserName = "";
            this.Email = "";
            this.IsEmailConfirmed = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Id = _data["Id"] !== undefined ? _data["Id"] : "";
            this.UserName = _data["UserName"] !== undefined ? _data["UserName"] : "";
            this.Email = _data["Email"] !== undefined ? _data["Email"] : "";
            this.FirstName = _data["FirstName"] !== undefined ? _data["FirstName"] : <any>null;
            this.LastName = _data["LastName"] !== undefined ? _data["LastName"] : <any>null;
            this.Company = _data["Company"] !== undefined ? _data["Company"] : <any>null;
            this.Title = _data["Title"] !== undefined ? _data["Title"] : <any>null;
            this.IsEmailConfirmed = _data["IsEmailConfirmed"] !== undefined ? _data["IsEmailConfirmed"] : false;
        }
    }

    static fromJS(data: any): ProfileViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.Id !== undefined ? this.Id : <any>null;
        data["UserName"] = this.UserName !== undefined ? this.UserName : <any>null;
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        data["FirstName"] = this.FirstName !== undefined ? this.FirstName : <any>null;
        data["LastName"] = this.LastName !== undefined ? this.LastName : <any>null;
        data["Company"] = this.Company !== undefined ? this.Company : <any>null;
        data["Title"] = this.Title !== undefined ? this.Title : <any>null;
        data["IsEmailConfirmed"] = this.IsEmailConfirmed !== undefined ? this.IsEmailConfirmed : <any>null;
        return data;
    }
}

export interface IProfileViewModel {
    Id: string;
    UserName: string;
    Email: string;
    FirstName?: string | null;
    LastName?: string | null;
    Company?: string | null;
    Title?: string | null;
    IsEmailConfirmed: boolean;
}

export class RefreshRequest implements IRefreshRequest {
    RefreshToken!: string;

    constructor(data?: IRefreshRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.RefreshToken = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.RefreshToken = _data["RefreshToken"] !== undefined ? _data["RefreshToken"] : "";
        }
    }

    static fromJS(data: any): RefreshRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RefreshToken"] = this.RefreshToken !== undefined ? this.RefreshToken : <any>null;
        return data;
    }
}

export interface IRefreshRequest {
    RefreshToken: string;
}

export class ResendConfirmationEmailRequest implements IResendConfirmationEmailRequest {
    Email!: string;

    constructor(data?: IResendConfirmationEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Email = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Email = _data["Email"] !== undefined ? _data["Email"] : "";
        }
    }

    static fromJS(data: any): ResendConfirmationEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResendConfirmationEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        return data;
    }
}

export interface IResendConfirmationEmailRequest {
    Email: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    Email!: string;
    ResetCode!: string;
    NewPassword!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Email = "";
            this.ResetCode = "";
            this.NewPassword = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Email = _data["Email"] !== undefined ? _data["Email"] : "";
            this.ResetCode = _data["ResetCode"] !== undefined ? _data["ResetCode"] : "";
            this.NewPassword = _data["NewPassword"] !== undefined ? _data["NewPassword"] : "";
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        data["ResetCode"] = this.ResetCode !== undefined ? this.ResetCode : <any>null;
        data["NewPassword"] = this.NewPassword !== undefined ? this.NewPassword : <any>null;
        return data;
    }
}

export interface IResetPasswordRequest {
    Email: string;
    ResetCode: string;
    NewPassword: string;
}

export class SiteConfiguration implements ISiteConfiguration {
    id!: string;
    name!: string;
    url!: string;

    constructor(data?: ISiteConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = "";
            this.name = "";
            this.url = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : "";
            this.name = _data["name"] !== undefined ? _data["name"] : "";
            this.url = _data["url"] !== undefined ? _data["url"] : "";
        }
    }

    static fromJS(data: any): SiteConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SiteConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface ISiteConfiguration {
    id: string;
    name: string;
    url: string;
}

export class TwoFactorRequest implements ITwoFactorRequest {
    Enable?: boolean | null;
    TwoFactorCode?: string | null;
    ResetSharedKey!: boolean;
    ResetRecoveryCodes!: boolean;
    ForgetMachine!: boolean;

    constructor(data?: ITwoFactorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ResetSharedKey = false;
            this.ResetRecoveryCodes = false;
            this.ForgetMachine = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Enable = _data["Enable"] !== undefined ? _data["Enable"] : <any>null;
            this.TwoFactorCode = _data["TwoFactorCode"] !== undefined ? _data["TwoFactorCode"] : <any>null;
            this.ResetSharedKey = _data["ResetSharedKey"] !== undefined ? _data["ResetSharedKey"] : false;
            this.ResetRecoveryCodes = _data["ResetRecoveryCodes"] !== undefined ? _data["ResetRecoveryCodes"] : false;
            this.ForgetMachine = _data["ForgetMachine"] !== undefined ? _data["ForgetMachine"] : false;
        }
    }

    static fromJS(data: any): TwoFactorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Enable"] = this.Enable !== undefined ? this.Enable : <any>null;
        data["TwoFactorCode"] = this.TwoFactorCode !== undefined ? this.TwoFactorCode : <any>null;
        data["ResetSharedKey"] = this.ResetSharedKey !== undefined ? this.ResetSharedKey : <any>null;
        data["ResetRecoveryCodes"] = this.ResetRecoveryCodes !== undefined ? this.ResetRecoveryCodes : <any>null;
        data["ForgetMachine"] = this.ForgetMachine !== undefined ? this.ForgetMachine : <any>null;
        return data;
    }
}

export interface ITwoFactorRequest {
    Enable?: boolean | null;
    TwoFactorCode?: string | null;
    ResetSharedKey: boolean;
    ResetRecoveryCodes: boolean;
    ForgetMachine: boolean;
}

export class TwoFactorResponse implements ITwoFactorResponse {
    SharedKey!: string;
    RecoveryCodesLeft!: number;
    RecoveryCodes?: string[] | null;
    IsTwoFactorEnabled!: boolean;
    IsMachineRemembered!: boolean;

    constructor(data?: ITwoFactorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.SharedKey = "";
            this.RecoveryCodesLeft = 0;
            this.IsTwoFactorEnabled = false;
            this.IsMachineRemembered = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.SharedKey = _data["SharedKey"] !== undefined ? _data["SharedKey"] : "";
            this.RecoveryCodesLeft = _data["RecoveryCodesLeft"] !== undefined ? _data["RecoveryCodesLeft"] : 0;
            if (Array.isArray(_data["RecoveryCodes"])) {
                this.RecoveryCodes = [] as any;
                for (let item of _data["RecoveryCodes"])
                    this.RecoveryCodes!.push(item);
            }
            else {
                this.RecoveryCodes = <any>null;
            }
            this.IsTwoFactorEnabled = _data["IsTwoFactorEnabled"] !== undefined ? _data["IsTwoFactorEnabled"] : false;
            this.IsMachineRemembered = _data["IsMachineRemembered"] !== undefined ? _data["IsMachineRemembered"] : false;
        }
    }

    static fromJS(data: any): TwoFactorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SharedKey"] = this.SharedKey !== undefined ? this.SharedKey : <any>null;
        data["RecoveryCodesLeft"] = this.RecoveryCodesLeft !== undefined ? this.RecoveryCodesLeft : <any>null;
        if (Array.isArray(this.RecoveryCodes)) {
            data["RecoveryCodes"] = [];
            for (let item of this.RecoveryCodes)
                data["RecoveryCodes"].push(item);
        }
        data["IsTwoFactorEnabled"] = this.IsTwoFactorEnabled !== undefined ? this.IsTwoFactorEnabled : <any>null;
        data["IsMachineRemembered"] = this.IsMachineRemembered !== undefined ? this.IsMachineRemembered : <any>null;
        return data;
    }
}

export interface ITwoFactorResponse {
    SharedKey: string;
    RecoveryCodesLeft: number;
    RecoveryCodes?: string[] | null;
    IsTwoFactorEnabled: boolean;
    IsMachineRemembered: boolean;
}

export class UserInfo implements IUserInfo {
    Email?: string | null;
    UserName?: string | null;
    Roles!: string[];
    Sites!: SiteConfiguration[];

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.Roles = [];
            this.Sites = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.Email = _data["Email"] !== undefined ? _data["Email"] : <any>null;
            this.UserName = _data["UserName"] !== undefined ? _data["UserName"] : <any>null;
            if (Array.isArray(_data["Roles"])) {
                this.Roles = [] as any;
                for (let item of _data["Roles"])
                    this.Roles!.push(item);
            }
            else {
                this.Roles = <any>null;
            }
            if (Array.isArray(_data["Sites"])) {
                this.Sites = [] as any;
                for (let item of _data["Sites"])
                    this.Sites!.push(SiteConfiguration.fromJS(item));
            }
            else {
                this.Sites = <any>null;
            }
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Email"] = this.Email !== undefined ? this.Email : <any>null;
        data["UserName"] = this.UserName !== undefined ? this.UserName : <any>null;
        if (Array.isArray(this.Roles)) {
            data["Roles"] = [];
            for (let item of this.Roles)
                data["Roles"].push(item);
        }
        if (Array.isArray(this.Sites)) {
            data["Sites"] = [];
            for (let item of this.Sites)
                data["Sites"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserInfo {
    Email?: string | null;
    UserName?: string | null;
    Roles: string[];
    Sites: SiteConfiguration[];
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}